export default "/images/vendor/flag-icons/flags/1x1/va.svg?523b1954ab03eb8a41e843f7bd4d748e";